import React from 'react';
import { Star } from 'lucide-react';
import VendorReviews from '../VendorReviews';

const ReviewsTab = ({
  serviceRating,
  serviceReviews,
  serviceRatingStats,
  vendorId,
}) => {
  return (
    <div className="space-y-8">
      <div className="border-b border-m-border-light pb-6">
        <div className="flex flex-col items-start gap-8 lg:flex-row">
          <div>
            <div className="mb-3 text-4xl font-medium tracking-tight text-m-ink sm:text-5xl">
              {serviceRating.toFixed(1)}
            </div>
            <div className="mb-2 flex">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  key={star}
                  className={`h-4 w-4 sm:h-5 sm:w-5 ${
                    star <= Math.floor(serviceRating)
                      ? 'fill-current text-m-ink'
                      : 'text-m-border-light'
                  }`}
                />
              ))}
            </div>
            <div className="text-sm text-m-ink-muted sm:text-base">
              Based on {serviceReviews} reviews
            </div>
          </div>

          <div className="w-full flex-1">
            <h4 className="mb-4 text-sm font-medium text-m-ink sm:text-base">
              Rating distribution
            </h4>
            <div className="space-y-3">
              {[5, 4, 3, 2, 1].map((rating) => {
                const count =
                  serviceRatingStats[
                    `${
                      rating === 5
                        ? 'five'
                        : rating === 4
                          ? 'four'
                          : rating === 3
                            ? 'three'
                            : rating === 2
                              ? 'two'
                              : 'one'
                    }_star`
                  ] || 0;
                const percentage =
                  serviceReviews > 0 ? (count / serviceReviews) * 100 : 0;

                return (
                  <div key={rating} className="flex items-center gap-3">
                    <div className="flex w-8 items-center">
                      <span className="text-xs text-m-ink-muted sm:text-sm">
                        {rating}
                      </span>
                      <Star className="ml-1 h-3 w-3 fill-current text-m-ink sm:h-4 sm:w-4" />
                    </div>
                    <div className="h-2 flex-1 rounded-full bg-m-border-light">
                      <div
                        className="h-2 rounded-full bg-m-ink transition-all duration-500"
                        style={{ width: `${percentage}%` }}
                      />
                    </div>
                    <span className="w-12 text-right text-xs text-m-ink-muted sm:text-sm">
                      {count}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div>
        {vendorId ? (
          <VendorReviews vendorId={vendorId} />
        ) : (
          <div className="rounded-2xl border border-m-border-light bg-m-surface py-12 text-center">
            <Star className="mx-auto mb-4 h-12 w-12 text-m-ink-faint" />
            <h4 className="mb-2 text-lg font-medium tracking-tight text-m-ink">
              No reviews yet
            </h4>
            <p className="text-sm text-m-ink-muted">
              Be the first to review this service after your booking.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewsTab;
